export const instagramMapStyle = JSON.stringify({
    version: 8,
    name: 'KeepTouch Instagram Style',
    sources: {
      'openmaptiles': {
        type: 'vector',
        url: 'mapbox://mapbox.mapbox-streets-v8',
      },
    },
    sprite: 'mapbox://sprites/mapbox/light-v11',
    glyphs: 'mapbox://fonts/mapbox/{fontstack}/{range}.pbf',
    layers: [
      {
        id: 'background',
        type: 'background',
        paint: {
          'background-color': '#F6F6F6',
        },
      },
      {
        id: 'landuse-park',
        type: 'fill',
        source: 'openmaptiles',
        'source-layer': 'landuse',
        filter: ['in', 'class', 'park', 'pitch', 'grass', 'cemetery', 'garden'],
        paint: {
          'fill-color': '#E8F0E4',
          'fill-opacity': 0.7,
        },
      },
      {
        id: 'landuse-forest',
        type: 'fill',
        source: 'openmaptiles',
        'source-layer': 'landuse',
        filter: ['in', 'class', 'wood', 'scrub'],
        paint: {
          'fill-color': '#DDE9D8',
          'fill-opacity': 0.5,
        },
      },
      {
        id: 'water',
        type: 'fill',
        source: 'openmaptiles',
        'source-layer': 'water',
        paint: {
          'fill-color': '#D4E4F1',
        },
      },
      {
        id: 'waterway',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'waterway',
        paint: {
          'line-color': '#D4E4F1',
          'line-width': 1.5,
        },
      },
      {
        id: 'building',
        type: 'fill',
        source: 'openmaptiles',
        'source-layer': 'building',
        minzoom: 14,
        paint: {
          'fill-color': '#EDEDEC',
          'fill-opacity': 0.6,
        },
      },
      {
        id: 'tunnel-path',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'road',
        filter: ['all', ['==', 'structure', 'tunnel'], ['in', 'class', 'path', 'pedestrian']],
        paint: {
          'line-color': '#E8E8E8',
          'line-width': 1,
          'line-dasharray': [2, 2],
        },
      },
      {
        id: 'road-path',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'road',
        filter: ['all', ['!has', 'structure'], ['in', 'class', 'path', 'pedestrian', 'track']],
        paint: {
          'line-color': '#E8E8E8',
          'line-width': 1,
        },
      },
      {
        id: 'road-minor',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'road',
        filter: ['all', ['!has', 'structure'], ['in', 'class', 'minor_road', 'service', 'street']],
        paint: {
          'line-color': '#FFFFFF',
          'line-width': ['interpolate', ['linear'], ['zoom'], 10, 0.5, 14, 2, 18, 8],
        },
      },
      {
        id: 'road-secondary',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'road',
        filter: ['all', ['!has', 'structure'], ['in', 'class', 'secondary', 'tertiary']],
        paint: {
          'line-color': '#FFFFFF',
          'line-width': ['interpolate', ['linear'], ['zoom'], 8, 0.5, 14, 3, 18, 12],
        },
      },
      {
        id: 'road-primary',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'road',
        filter: ['all', ['!has', 'structure'], ['in', 'class', 'primary']],
        paint: {
          'line-color': '#FFFFFF',
          'line-width': ['interpolate', ['linear'], ['zoom'], 6, 0.5, 14, 4, 18, 14],
        },
      },
      {
        id: 'road-trunk',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'road',
        filter: ['all', ['!has', 'structure'], ['in', 'class', 'trunk']],
        paint: {
          'line-color': '#F5DEB3',
          'line-width': ['interpolate', ['linear'], ['zoom'], 6, 0.5, 14, 4, 18, 16],
          'line-opacity': 0.6,
        },
      },
      {
        id: 'road-motorway',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'road',
        filter: ['all', ['!has', 'structure'], ['==', 'class', 'motorway']],
        paint: {
          'line-color': '#F5DEB3',
          'line-width': ['interpolate', ['linear'], ['zoom'], 6, 1, 14, 5, 18, 18],
          'line-opacity': 0.6,
        },
      },
      {
        id: 'bridge-minor',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'road',
        filter: ['all', ['==', 'structure', 'bridge'], ['in', 'class', 'minor_road', 'service', 'street']],
        paint: {
          'line-color': '#FFFFFF',
          'line-width': ['interpolate', ['linear'], ['zoom'], 10, 0.5, 14, 2, 18, 8],
        },
      },
      {
        id: 'bridge-major',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'road',
        filter: ['all', ['==', 'structure', 'bridge'], ['in', 'class', 'primary', 'secondary', 'tertiary', 'trunk', 'motorway']],
        paint: {
          'line-color': '#FFFFFF',
          'line-width': ['interpolate', ['linear'], ['zoom'], 8, 1, 14, 4, 18, 14],
        },
      },
      {
        id: 'admin-country',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'admin',
        filter: ['==', 'admin_level', 2],
        paint: {
          'line-color': '#CDCDCD',
          'line-width': 1.2,
          'line-dasharray': [3, 2],
        },
      },
      {
        id: 'admin-state',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'admin',
        filter: ['==', 'admin_level', 4],
        paint: {
          'line-color': '#DEDEDE',
          'line-width': 0.8,
          'line-dasharray': [3, 2],
        },
      },
      {
        id: 'label-water',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'natural_label',
        filter: ['in', 'class', 'water', 'ocean', 'sea', 'bay'],
        layout: {
          'text-field': ['get', 'name'],
          'text-font': ['DIN Pro Italic', 'Arial Unicode MS Regular'],
          'text-size': ['interpolate', ['linear'], ['zoom'], 3, 10, 10, 14],
          'text-letter-spacing': 0.1,
        },
        paint: {
          'text-color': '#A0BDD0',
          'text-halo-color': 'rgba(255,255,255,0.5)',
          'text-halo-width': 1,
        },
      },
      {
        id: 'label-country',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place_label',
        filter: ['==', 'class', 'country'],
        layout: {
          'text-field': ['get', 'name'],
          'text-font': ['DIN Pro Medium', 'Arial Unicode MS Regular'],
          'text-size': ['interpolate', ['linear'], ['zoom'], 2, 10, 6, 16],
          'text-transform': 'uppercase',
          'text-letter-spacing': 0.15,
        },
        paint: {
          'text-color': '#AAAAAA',
          'text-halo-color': '#F6F6F6',
          'text-halo-width': 1.5,
        },
      },
      {
        id: 'label-state',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place_label',
        filter: ['==', 'class', 'state'],
        minzoom: 4,
        layout: {
          'text-field': ['get', 'name'],
          'text-font': ['DIN Pro Regular', 'Arial Unicode MS Regular'],
          'text-size': ['interpolate', ['linear'], ['zoom'], 4, 9, 8, 13],
          'text-transform': 'uppercase',
          'text-letter-spacing': 0.15,
        },
        paint: {
          'text-color': '#BBBBBB',
          'text-halo-color': '#F6F6F6',
          'text-halo-width': 1,
        },
      },
      {
        id: 'label-city-large',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place_label',
        filter: ['all', ['==', 'class', 'settlement'], ['>=', 'symbolrank', 0], ['<=', 'symbolrank', 6]],
        layout: {
          'text-field': ['get', 'name'],
          'text-font': ['DIN Pro Medium', 'Arial Unicode MS Regular'],
          'text-size': ['interpolate', ['linear'], ['zoom'], 4, 10, 10, 18],
          'text-anchor': 'center',
        },
        paint: {
          'text-color': '#666666',
          'text-halo-color': '#F6F6F6',
          'text-halo-width': 1.5,
        },
      },
      {
        id: 'label-city-medium',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place_label',
        filter: ['all', ['==', 'class', 'settlement'], ['>', 'symbolrank', 6], ['<=', 'symbolrank', 12]],
        minzoom: 6,
        layout: {
          'text-field': ['get', 'name'],
          'text-font': ['DIN Pro Regular', 'Arial Unicode MS Regular'],
          'text-size': ['interpolate', ['linear'], ['zoom'], 6, 9, 12, 15],
          'text-anchor': 'center',
        },
        paint: {
          'text-color': '#888888',
          'text-halo-color': '#F6F6F6',
          'text-halo-width': 1,
        },
      },
      {
        id: 'label-city-small',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place_label',
        filter: ['all', ['==', 'class', 'settlement'], ['>', 'symbolrank', 12]],
        minzoom: 9,
        layout: {
          'text-field': ['get', 'name'],
          'text-font': ['DIN Pro Regular', 'Arial Unicode MS Regular'],
          'text-size': ['interpolate', ['linear'], ['zoom'], 9, 9, 14, 13],
          'text-anchor': 'center',
        },
        paint: {
          'text-color': '#999999',
          'text-halo-color': '#F6F6F6',
          'text-halo-width': 1,
        },
      },
    ],
  })